"use client";

import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { normalizeSingleFilterFormData } from "@/helpers/request-helpers";
import { IStockMovement } from "@/interfaces/sku-movement.interfaces";
import stockMovementService from "@/services/stock-movement.service";
import { IFilter } from "@/types/filter.types";
import {
  GetRequestProps,
  PaginatedResponse,
  RequestPagination,
  RequestsBaseReturn,
} from "@/types/requests.types";

export type UseGetStockMovementsReturn =
  RequestsBaseReturn<PaginatedResponse<IStockMovement> | null>;

export interface UseGetStockMovementsProps extends RequestPagination, GetRequestProps {
  filters: IFilter<IStockMovement>[];
  skuId: number;
}

type GetAllSwrParams = [string, number, number, IFilter<IStockMovement>[]];

const useGetStockMovements = ({
  pageNumber,
  pageSize,
  filters,
  isPaused = false,
}: UseGetStockMovementsProps): UseGetStockMovementsReturn => {
  const normalizedFilter = normalizeSingleFilterFormData(filters, "comments");

  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<PaginatedResponse<IStockMovement>, Error, GetAllSwrParams>(
    [SWR_KEYS.getStockMovements, pageNumber, pageSize, normalizedFilter],
    ([, _pageNumber, _pageSize, _filters]) =>
      stockMovementService.filter(_filters, {
        pageNumber: _pageNumber,
        pageSize: _pageSize,
      }),
    {
      revalidateOnFocus: false,
      isPaused: () => isPaused,
    }
  );

  return { data, isLoading, error };
};

export default useGetStockMovements;
